import { Icon, type IconName, Text } from "@assetwatch/ui";

export type ProcedureItemIconType =
  | "text"
  | "checkbox"
  | "number"
  | "choice"
  | "photo";

type ProcedureItemIconSize = "xs" | "sm";

const itemTypeIcons: Record<
  Exclude<ProcedureItemIconType, "number">,
  IconName
> = {
  text: "document",
  checkbox: "check-mark",
  choice: "checklist",
  photo: "camera-regular",
};

export function ProcedureItemTypeIcon({
  type,
  size,
}: {
  type: ProcedureItemIconType;
  size: ProcedureItemIconSize;
}) {
  if (type === "number") {
    const dimension = size === "xs" ? "var(--icon-xs)" : "var(--icon-sm)";
    /* @ds-deviation: the icon set has no hash glyph, so the Numeric step marker is a "#" in DS Text sized to the icon box — promote a hash icon into the design system */
    return (
      <span
        aria-hidden="true"
        data-step-type-icon="number"
        className="inline-flex shrink-0 items-center justify-center"
        style={{ width: dimension, height: dimension }}
      >
        <Text as="span" size={size === "xs" ? "sm" : "md"} weight="semibold">
          #
        </Text>
      </span>
    );
  }
  return (
    <Icon
      aria-hidden="true"
      data-step-type-icon={type}
      name={itemTypeIcons[type]}
      size={size}
    />
  );
}
